import { apiFetcher } from '../api-fetcher';


type CreateProductLinkResponse = {
  data : {
    shortLink:string;
  }
}

type CreateFullWebViewLinkRequest = {
  url:string;
  fallbackType?:'SELF'|'AIR_PAGE'; // default "SELF"
  ogTagSourceCollapse?:"DEFAULT"|"SELF"; // default "DEFAULT"
  utmCollapse? : {
    utmSource?:string;
    utmCampaign?:string;
    utmMedium?:string;
    utmTerm?:string;
    utmContent?:string;
  } 

}

type CreateFullWebViewLinkResponse = {
  data: {
    shortLink: string;
  }
}

export const createProductLink =  (pid:number) => {
  return apiFetcher.post<CreateProductLinkResponse>(`/api/shortlink/v1/short-links/product`, {
    pid,
  });
};


export const createFullWebViewLink = (params:CreateFullWebViewLinkRequest) => {
  return apiFetcher.post<CreateFullWebViewLinkResponse>(`/api/shortlink/v1/short-links/full-webview`, params);
}